/* js/modal.js */

;(function($, window, document) {

    $(document).on('ready', function() {

        var $trigger = $('.messe-inspiration--trigger'),
            $target = $('.messe-inspiration'),
            openCls = 'is--open';

        $trigger.on('click', function(){
            $target.toggleClass(openCls);
        });

    });

})(jQuery, window, document);